import { Store } from "./store";

export class VenueKitchenDevicePreferences {
	venueKey: number;

	venue: Store;

	viewRows: boolean;

	viewType: boolean;

	graphicsMode: boolean;

	urgentTime: number;
	maxRetryDuration: number;
	orderReadySmsMessage: string;
	orderTypeSettings: KitchenOrderTypeOverride[];

	public constructor(init?: Partial<VenueKitchenDevicePreferences>) {
		Object.assign(this, init);
	}
}

export class KitchenOrderTypeOverride {
	orderTypeName: string;
	color: string;
	lineOrderTypeName?: string;
	expoOrderTypeName?: string;

	public constructor(init?: Partial<KitchenOrderTypeOverride>) {
		Object.assign(this, init);
	}
}
